var colors = {
    white: 'rgba(255, 255, 255, 1)',
    secondaryText: 'rgba(42, 42, 43, 1)',
    surface1: 'rgba(103, 107, 115, 1)',
    surface2: 'rgba(191, 192, 195, 1)',
    surface3: 'rgba(215, 216, 219, 1)',
    surface4: 'rgba(234, 235, 236, 1)',
    surface5: 'rgba(251, 251, 251, 1)',
    disabled: 'rgba(144, 144, 145, 1)',
    primary: 'rgba(116, 55, 245, 1)',
    primaryHover: 'rgba(155, 99, 255, 1)',
    primaryPressed: 'rgba(66, 18, 153, 1)',
    secondary: 'rgba(246, 242, 255, 1)',
    secondaryHover: 'rgba(232, 222, 255, 1)',
    secondaryPressed: 'rgba(202, 182, 236, 1)',
    thirdary: 'rgba(243, 207, 255, 1)',
    thirdaryHover: 'rgba(250, 235, 255, 1)',
    thirdaryPressed: 'rgba(215, 170, 231, 1)',
    error: 'rgba(242, 80, 80, 1)',
    errorHover: 'rgba(255, 140, 140, 1)',
    errorPressed: 'rgba(176, 0, 0, 1)',
    redNotice: 'rgba(255, 190, 190, 1)',
    warning: 'rgba(255, 172, 77, 1)',
    warningHover: 'rgba(255, 207, 152, 1)',
    warningPressed: 'rgba(223, 134, 33, 1)',
    warning2: 'rgba(255, 219, 156, 1)',
    success: 'rgba(4, 178, 24, 1)',
    successHover: 'rgba(117, 233, 117, 1)',
    successPressed: 'rgba(18, 134, 18, 1)',
    info: 'rgba(87, 173, 255, 1)',
    navGray: 'rgba(117, 121, 130, 1)',
    branding: {
        primary: 'rgba(86, 0, 239, 1)',
        secondary: 'rgba(255, 0, 122, 1)',
        tertiary: 'rgba(252, 255, 0, 1)',
        tertiaryHover: 'rgba(254, 255, 141, 1)',
        tertiaryPressed: 'rgba(243, 218, 26, 1)',
        quaternary: 'rgba(0, 255, 137, 1)',
    },
    surfaceFamilies: {
        primary: 'rgba(255, 255, 255, 1)',
        primaryHover: 'rgba(246, 246, 247, 1)',
        primaryPressed: 'rgba(241, 242, 243, 1)',
        primaryDisabled: 'rgba(246, 246, 246, 1)',
        selected: 'rgba(248, 246, 254, 1)',
        selectedHover: 'rgba(242, 240, 255, 1)',
        selectedPressed: 'rgba(235, 231, 255, 1)',
        warning: 'rgba(255, 247, 237, 1)',
        warningHover: 'rgba(251, 236, 219, 1)',
        warningPressed: 'rgba(250, 224, 195, 1)',
        error: 'rgba(255, 245, 245, 1)',
        errorHover: 'rgba(255, 232, 233, 1)',
        errorPressed: 'rgba(253, 226, 227, 1)',
        success: 'rgba(238, 251, 238, 1)',
        successHover: 'rgba(221, 244, 221, 1)',
        successPressed: 'rgba(211, 242, 211, 1)',
        highlights: 'rgba(239, 247, 254, 1)',
        highlightsHover: 'rgba(227, 241, 255, 1)',
        highlightsPressed: 'rgba(211, 231, 251, 1)',
    },
    decorative: {
        primary: 'rgba(242, 245, 254, 1)',
        primaryHover: 'rgba(235, 239, 253, 1)',
        primaryPressed: 'rgba(229, 235, 253, 1)',
        secondary: 'rgba(252, 245, 240, 1)',
        secondaryHover: 'rgba(252, 240, 232, 1)',
        secondaryPressed: 'rgba(244, 220, 206, 1)',
        thirdary: 'rgba(255, 235, 250, 1)',
        thirdaryHover: 'rgba(255, 226, 248, 1)',
        thirdaryPressed: 'rgba(246, 210, 238, 1)',
        success: 'rgba(228, 250, 217, 1)',
        successHover: 'rgba(205, 240, 187, 1)',
        successPressed: 'rgba(182, 232, 158, 1)',
        error: 'rgba(255, 219, 217, 1)',
        errorHover: 'rgba(255, 188, 184, 1)',
        errorPressed: 'rgba(250, 157, 150, 1)',
        info: 'rgba(219, 249, 255, 1)',
        infoHover: 'rgba(197, 243, 252, 1)',
        infoPressed: 'rgba(168, 234, 247, 1)',
        warning: 'rgba(249, 243, 232, 1)',
        warningHover: 'rgba(255, 237, 207, 1)',
        warningPressed: 'rgba(255, 226, 176, 1)',
    },
    link: {
        primary: "rgba(72, 119, 239, 1)",
        primaryHover: "rgba(109, 146, 242, 1)",
        primaryVisited: "rgba(52, 86, 172, 1)",
    },
    grey: {
        default: "rgba(249, 249, 249, 1)",
        grey5: "rgba(217, 217, 217, 1)",
        grey10: "rgba(206, 206, 206, 1)",
        grey20: "rgba(183, 183, 183, 1)",
        grey30: "rgba(161, 161, 161, 1)",
        grey40: "rgba(130, 130, 130, 1)",
        grey50: "rgba(114, 114, 114, 1)",
        grey60: "rgba(92, 92, 92, 1)",
        grey70: "rgba(69, 69, 69, 1)",
        grey80: "rgba(46, 46, 46, 1)",
        grey90: "rgba(23, 23, 23, 1)",
        grey100: "rgba(0, 0, 0, 1)",
    },
};
export default colors;
